module.exports = __webpack_public_path__ + "img/6.82ab36b5.jpg";